(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chatgpt-v61-collection-hero"] && !Shopify.designMode) return;
  try {
    /* CHATGPT VERSION 7.5 — START: adjust image resolution when the banner or description changes height */
  (() => {
    let images = [];

    function updateImage(image) {
      const ratio = Number(image.dataset.cg75AspectRatio);
      // CHATGPT VERSION 7.7 — START: measure the unchanged banner through the picture wrapper
      const media = image.closest('.cg64-hero__media');
      // CHATGPT VERSION 7.7 — END: banner measurement
      if (!media || !Number.isFinite(ratio) || ratio <= 0) return;
      const box = media.getBoundingClientRect();
      if (box.width <= 0 || box.height <= 0) return;
      const sizes = Math.ceil(Math.max(box.width, box.height * ratio)) + 'px';
      if (image.sizes !== sizes) image.sizes = sizes;
    }

    const observer = typeof ResizeObserver === 'function'
      ? new ResizeObserver(entries => {
          entries.forEach(entry => {
            const image = entry.target.querySelector('[data-cg75-aspect-ratio]');
            if (image) updateImage(image);
          });
        })
      : null;

    function initialize() {
      if (observer) observer.disconnect();
      images = Array.from(document.querySelectorAll('.cg61-hero__image[data-cg75-aspect-ratio]'));
      images.forEach(image => {
        updateImage(image);
        // CHATGPT VERSION 7.7 — START: keep mobile resize observation on the original media container
        const media = image.closest('.cg64-hero__media');
        if (observer && media) observer.observe(media);
        // CHATGPT VERSION 7.7 — END: mobile resize observation
      });
    }

    if (!observer) window.addEventListener('resize', () => images.forEach(updateImage), { passive: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(initialize));
  })();
  /* CHATGPT VERSION 7.5 — END: adjust image resolution when the banner or description changes height */
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chatgpt-v61-collection-style"] && !Shopify.designMode) return;
  try {
    /* CHATGPT VERSION 6.4 — START: measure the existing header without changing its layout */
  (() => {
    let cleanup = () => {};
    function initialize() {
      cleanup();
      const shell = document.getElementById('cg61-header-shell');
      const hero = document.querySelector('[data-cg61-hero]');
      if (!shell || !hero) return;
      shell.classList.toggle('cg61-over-image', hero.classList.contains('cg61-hero--image'));
      /* CHATGPT VERSION 7.1 — START: let embedded description colors follow the desktop caption */
      if (hero.classList.contains('cg61-hero--image')) {
        hero.querySelectorAll('.cg61-hero__description [style]').forEach(element => {
          const color = element.style.getPropertyValue('color');
          if (color && !color.includes('--cg71-caption-ink')) {
            const priority = element.style.getPropertyPriority('color');
            element.style.setProperty('color', 'var(--cg71-caption-ink, ' + color + ')', priority);
          }
        });
      }
      /* CHATGPT VERSION 7.1 — END: retain each embedded color as the phone fallback */
      let frame = 0;
      let active = true;
      function measure() {
        frame = 0;
        const height = shell.getBoundingClientRect().height + 'px';
        if (document.body.style.getPropertyValue('--cg61-header-height') !== height) {
          document.body.style.setProperty('--cg61-header-height', height);
        }
      }
      function schedule() { if (active && !frame) frame = requestAnimationFrame(measure); }
      const observer = new ResizeObserver(schedule);
      observer.observe(shell);
      window.addEventListener('resize', schedule, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
      measure();
      cleanup = () => {
        active = false;
        cancelAnimationFrame(frame);
        observer.disconnect();
        window.removeEventListener('resize', schedule);
      };
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:unload', initialize);
  })();
  /* CHATGPT VERSION 6.4 — END: measure the existing header without changing its layout */
  } catch(e) { console.error(e); }
})();

})();
